module.exports = __webpack_public_path__ + "static/media/android-chrome-512x512.b702c160.png";